import { render, staticRenderFns } from "./FormAllegro.vue?vue&type=template&id=91b04be0"
import script from "./FormAllegro.vue?vue&type=script&lang=js"
export * from "./FormAllegro.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports